import { CompaniesInvoiceElementsService_companyInvoiceElementsServiceGetGetInvoiceElements } from '@festina/moneyin-general-types/moneyin/hooks/CompaniesInvoiceElementsService_companyInvoiceElementsServiceGetGetInvoiceElements'

export const useFetchCompanyInvoiceElements =
  CompaniesInvoiceElementsService_companyInvoiceElementsServiceGetGetInvoiceElements.useSuspenseQuery
